import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ComicCard from '@/components/feature/ComicCard';
import SEOSchema from '@/components/feature/SEOSchema';
import { categories, getComicsByCategory, getCategoryName } from '@/mocks/comics';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const [activeSlug, setActiveSlug] = useState(slug || 'romance');

  useEffect(() => {
    if (slug) {
      setActiveSlug(slug);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [slug]);

  const categoryName = getCategoryName(activeSlug);
  const comics = getComicsByCategory(activeSlug);

  return (
    <>
      <SEOSchema type="WebPage" data={{
        name: `${categoryName} - 韩国漫画网`,
        description: `韩国漫画网${categoryName}分类频道，提供海量${categoryName}类韩漫免费漫画在线观看，支持下拉式免费阅读。`,
        url: `https://www.koreancomic.cn/category/${activeSlug}`,
      }} />
      <Navbar />
      <main>
        <Breadcrumb items={[
          { label: '首页', href: '/' },
          { label: '分类浏览' },
          { label: categoryName },
        ]} />

        <section className="py-10 md:py-14 bg-background-50">
          <div className="max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="mb-8">
              <h1 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
                {categoryName}漫画
              </h1>
              <p className="text-sm text-foreground-500 mt-2">
                浏览所有{categoryName}类韩漫，在线免费阅读，支持下拉式阅读体验
              </p>
            </div>

            <div className="flex flex-wrap items-center gap-2 mb-8">
              {categories.map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className={`px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap cursor-pointer ${
                    activeSlug === cat.slug
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:bg-background-200'
                  }`}
                >
                  {cat.name}
                </Link>
              ))}
            </div>

            {comics.length > 0 ? (
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5" data-product-shop>
                {comics.map((comic) => (
                  <ComicCard key={comic.id} comic={comic} />
                ))}
              </div>
            ) : (
              <div className="text-center py-20">
                <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-background-100 text-foreground-400 mb-4">
                  <i className="ri-inbox-line text-2xl"></i>
                </div>
                <p className="text-foreground-500">该分类暂无漫画内容</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}